import React from "react";
import { withAppState } from "../../state";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { withFocusable, Loading } from "../../services/visualLibraryService";
import {
  LandingPageStyled,
  LandingContainerStyled,
  ButtonModalStyled,
  LogoStyled,
  TextStyled,
  ImageStyled,
  LeftBlock,
  RightBlock,
  AlignText,
  MopBlock,
  StepNumber,
  StepContainer,
  StepText,
  StepTextContainer,
  PinLoginInfoContainer,
  PaymentMethodContainer
} from "./styles/Styled";
import { i18n } from "../../services/i18nService";
import { getAppState } from "../../state/index";
import { trackPage, trackEvent, getRedemptionSuccessTrackingData } from "../../services/analyticsService";
import { logout } from "../../services/authenticationService";
import { historyMethods } from "../../utils/historyMethods";
import { redirectTo } from "../../services/navigationService";
import { activate, checkForUmanagedOrNonChangeableMop } from "../../services/billingService";
import { routes, sections } from "../../routes";
import { getMopPaymentMethodFromBilling } from "../../utils/getMopPaymentMethodFromBilling";
import Logo from "../../components/Logo";
import { eVoucherProvisioning } from "../../services/eVoucherEligibilityService";
import { getSdk } from "../../services/sdkService";
import { getGlobalButtonFocusPath } from "../../errors/globalButtons";
import { config } from "../../config/config";
import { isAnyAddonStatusActive } from "../../utils/subscriptionUtils";

const PAGE = "nonchangeable";
const SIGNUP = "signup";
const ButtonModalFocus = withFocusable(ButtonModalStyled);
const retryFocusPath = "retryCheck_passThru";
const accountFocusPath = "differentAccount_passThru";
const closeFocusPath = "closeModal_passThru";

function getInvalidPaymentMethodModal() {
  let heading = `pages.nonchangeable.modal.heading`;
  let text = `pages.nonchangeable.modal.text`;

  return {
    dismissable: false,
    modalTitle: i18n.get(heading),
    modalText: i18n.get(text),
    buttons: [
      {
        label: i18n.get("pages.nonchangeable.modal.okButton"),
        displayBlock: true,
        focusPath: closeFocusPath,
        buttonHandler: () => this.closeModal()
      }
    ]
  };
}

function handleRequestError(error) {
  const { stateActions } = this.props;
  stateActions.showGlobalModal(getInvalidPaymentMethodModal.call(this));
  this.props.setFocus(closeFocusPath);
}

class NonChangeablePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false
    };
    this.onBack = this.onBack.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.enterHandler = this.enterHandler.bind(this);
    this.chooseAccountHandler = this.chooseAccountHandler.bind(this);
    this.redeemVoucher = this.redeemVoucher.bind(this);
  }
  componentDidMount() {
    this.props.onRef && this.props.onRef(this);
  }

  componentWillUnmount() {}

  enterHandler(eventAction, path, locationData) {
    // trackEvent(SIGNUP, eventAction);
    redirectTo.call(this, path, locationData, historyMethods.REPLACE);
  }

  async redeemVoucher() {
    const { voucherData } = getAppState();
    const {
      history: { location },
      setFocus
    } = this.props;
    try {
      this.setState({ isRedeeming: true });
      let baseCode = voucherData && voucherData.vouchers[0].code;
      let addonCode = undefined;
      this.setState({ isLoading: true });
      const paymentData = {
        paymentType: "voucher",
        paymentData: {
          voucherNumber: baseCode 
        }
      };
      if (voucherData) {
        if (voucherData.status === "INVALID") {
          throw voucherData;
        }
        const vouchers = voucherData.vouchers.reduce((acc, val) => {
          if (val.subscriptions.includes("starzplay")) {
            acc.baseCode = val.code;
          } else {
            acc.addonCode = val.code;
          }
          return acc;
        }, {});

        baseCode = vouchers.baseCode;
        addonCode = vouchers.addonCode;
      }
      const updatedUser = true ? await eVoucherProvisioning(baseCode, addonCode) : await activate(paymentData);

      const userInfo = await getSdk().userManager.get({ avoidCache: true });
      trackEvent(SIGNUP, "evoucher_redemption_success", getRedemptionSuccessTrackingData.call(this));
      this.setState({ isRedeeming: false });
      getAppState().currentProfileType = userInfo?.profileType;
      getAppState().userAccountStatus = userInfo.settings.accountStatus;
      getAppState().userAddonStatus = isAnyAddonStatusActive(userInfo?.settings?.addons);
      getAppState().addons = userInfo.settings.addons;
      //getAppState().voucherData = null;

      redirectTo.call(
        this,
        routes.thankyou,
        location && location.state && location.state.fromSignup && { fromSignup: location.state.fromSignup },
        historyMethods.REPLACE
      );
    } catch (e) {
      this.setState({ isLoading: false });
      this.setState({ isRedeeming: false });
      handleRequestError.call(this, e);
      setFocus(getGlobalButtonFocusPath("back"));
    } finally {
      this.setState({ isLoading: false });
    }
  }

  async chooseAccountHandler(locationData) {
    // trackEvent(SIGNUP, eventAction);
    const {
      stateActions: { userLoggedOut }
    } = this.props;
    const configuration = await config.request();
    const clientType = configuration.sdk.clientType;
    const isLGTV = clientType === "lg-webos" ? true : false;
    await logout(true, 'logout_promotion');
    userLoggedOut();
    redirectTo.call(this, isLGTV ? routes.promotions: routes.landing, locationData, historyMethods.REPLACE);
  }

  async checkForNonChangeable() {
    // trackEvent(SIGNUP, eventAction);
    this.setState({ isLoading: true });
    const isNonChangeable = await checkForUmanagedOrNonChangeableMop.call(this, true);
    this.setState({ isLoading: false });
    if (isNonChangeable) {
      handleRequestError.call(this, {});
    } else {
      redirectTo.call(this, routes.redeem, null, historyMethods.REPLACE);
    }
  }

  closeModal(redirectToLanding = false) {
    const {
      stateActions: { hideGlobalModal }
    } = this.props;
    hideGlobalModal();
    if (redirectToLanding) {
      redirectTo.call(this, routes.home, historyMethods.REPLACE);
    }
  }

  onBack() {
    const { applicationState } = this.props;
    if (applicationState && applicationState.voucherData) {
      redirectTo.call(this, routes.promotions, null, historyMethods.REPLACE);
      return true;
    }
    redirectTo.call(this, routes.home, null, historyMethods.REPLACE);
    return true;
  }

  render() {
    const {
      applicationState: { userLocale, userBilling }
    } = this.props;

    const paymentMethod = getMopPaymentMethodFromBilling(userBilling);
    return (
      <LandingPageStyled background={""}>
        {this.state.isLoading && <Loading overlay />}
        <PinLoginInfoContainer>
          <LeftBlock userLocale={userLocale}>
            <LandingContainerStyled>
              <TextStyled rank="1" text={i18n.get("pages.nonchangeable.sections.left.heading1")} size="large" />
              <TextStyled rank="1" text={i18n.get("pages.nonchangeable.sections.left.heading2")} size="default" />
              <PaymentMethodContainer>
                <MopBlock>
                  <TextStyled
                    rank="1"
                    text={i18n.get("pages.nonchangeable.sections.left.paymentMethod")}
                    size="default"
                  />
                  {paymentMethod && paymentMethod.configuration && (
                    <ImageStyled src={paymentMethod.configuration.logoPNG} alt="" height="35" />
                  )}
                  {paymentMethod && <TextStyled rank="1" text={paymentMethod.displayName} size="default" />}
                </MopBlock>
              </PaymentMethodContainer>
              <ButtonModalFocus
                label={i18n.get("pages.nonchangeable.sections.left.retryButton")}
                displayBlock
                focusPath={retryFocusPath}
                onEnterPress={() => this.checkForNonChangeable()}
                onMouseUp={() => this.checkForNonChangeable()}
                size="medium"
                dataSnUp={""}
                dataSnDown={`@${accountFocusPath}`}
                dataSnLeft={""}
                dataSnRight={""}
              />
              <TextStyled
                rank="1"
                text={i18n.get("pages.nonchangeable.sections.left.differentAccount")}
                size="default"
              />
              <ButtonModalFocus
                label={i18n.get("pages.nonchangeable.sections.left.differentAccountButton")}
                displayBlock
                focusPath={accountFocusPath}
                onEnterPress={() => this.chooseAccountHandler()}
                onMouseUp={() => this.chooseAccountHandler()}
                size="medium"
                dataSnUp={`@${retryFocusPath}`}
                dataSnDown={""}
                dataSnLeft={""}
                dataSnRight={""}
              />
            </LandingContainerStyled>
          </LeftBlock>
          <RightBlock userLocale={userLocale}>
            <AlignText>
              <LogoStyled>
                <Logo />
              </LogoStyled>
            </AlignText>

            <LandingContainerStyled>
              <TextStyled rank="1" text={i18n.get("pages.nonchangeable.sections.right.heading1")} size="default" />
              <TextStyled rank="1" text={i18n.get("pages.nonchangeable.sections.right.heading2")} size="default" />
              <StepContainer userLocale={userLocale}>
                <StepNumber>1</StepNumber>
                <StepTextContainer>
                  <StepText rank="3" text={i18n.get("pages.nonchangeable.sections.right.step1")} size="default" />
                </StepTextContainer>
              </StepContainer>
              <StepContainer userLocale={userLocale}>
                <StepNumber>2</StepNumber>
                <StepTextContainer>
                  <StepText rank="3" text={i18n.get("pages.nonchangeable.sections.right.step2")} size="default" />
                </StepTextContainer>
              </StepContainer>
            </LandingContainerStyled>
          </RightBlock>
        </PinLoginInfoContainer>
      </LandingPageStyled>
    );
  }
}

export default withAppState(withSubtheme(NonChangeablePage));
